import type { PropsWithChildren } from "react";
import { useChatbotPanel } from "../../hooks/use-chatbot-panel/use-chatbot-panel";

function CloseChatbotPanelWrapper({ children }: PropsWithChildren<{}>): JSX.Element {
  const { closeChatbotPanel } = useChatbotPanel();
  closeChatbotPanel();
  return <>{children}</>;
}

export default CloseChatbotPanelWrapper;
